import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit'
import userSlice from './features/userSlice'
import variationSlice from './features/variationSlice'

const storageMiddleware = createListenerMiddleware()

export const store = configureStore({
  reducer: {
    user: userSlice,
    productVariation: variationSlice,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(storageMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
